export const CHAT_TITLE_MAX_LENGTH = 30;
export const MAX_SELECT_COUNT = 1000;

export const HISTORY_OPERATE_TYPE = {
  DC_RENAME: 'dc_rename',
  RENAME: 'rename',
  FAVORITE: 'favourite',
  UNFAVORITE: 'unfavourite',
  DELETE: 'delete',
  MANAGE: 'manage',
};
